import type { ShipmentTag } from '../domain/ShipmentTag'

export type RawShipmentTag = {
  uuid: string
  name: string
  color: string
}

export function mapApiToTags(tags?: Array<RawShipmentTag> | null): Array<ShipmentTag> | undefined {
  if (!tags?.length) return undefined

  return tags.map(tag => ({
    name: tag.name,
    color: tag.color,
  }))
}
